import api from "./api";
import API_ROUTES from "./apiRoutes";

export const getUsers = async (societyId = null) => {
  try {
    const res = await api.get(API_ROUTES.users.list, {
      params: societyId ? { societyId } : undefined,
    });
    return res.data;
  } catch (err) {
    console.error("GET USERS ERROR:", err);
    throw err;
  }
};

export const getUserFlatMappings = async (userId) => {
  const res = await api.get(API_ROUTES.users.flats(userId));
  return res.data;
};

export const createUser = async (data) => {
  try {
    const res = await api.post(API_ROUTES.users.list, data);
    return res.data;
  } catch (err) {
    console.error("CREATE USER ERROR:", err);
    throw err;
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await api.delete(API_ROUTES.users.details(id));
    return res.data;
  } catch (err) {
    console.error("DELETE USER ERROR:", err);
    throw err;
  }
};

export const updateUser = async (id, data) => {
  try {
    const res = await api.put(API_ROUTES.users.details(id), data);
    return res.data;
  } catch (err) {
    console.error("UPDATE USER ERROR:", err);
    throw err;
  }
};

export const getUserStats = async () => {
  const res = await api.get(API_ROUTES.users.stats);
  return res.data;
};

export const getMyProfile = async () => {
  const res = await api.get(API_ROUTES.users.me);
  return res.data;
};

export const activateUser = async (id, data = {}) => {
  try {
    const res = await api.patch(API_ROUTES.users.activate(id), data);
    return res.data;
  } catch (err) {
    console.error("ACTIVATE USER ERROR:", err);
    throw err;
  }
};
